export const convertMillisecondsToSeconds = (milliseconds: number): number => {
  return Math.floor(milliseconds / 1000);
};
